import React, { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { useLocalStorage } from '../hooks/useLocalStorage';
import Icon from './icon/Icon';
import Button from './bootstrap/Button';
import { initTelemetry } from '../telemetry';
import { initGA } from '../analytics/ga';
import './CookieConsent.css';

const CookieConsent: React.FC = () => {
	const { t } = useTranslation();
	// null = no choice made yet, true = accepted, false = rejected
	const [consent, setConsent] = useLocalStorage<boolean | null>('cookie-consent', null);

	// If user previously accepted, initialise telemetry on mount
	useEffect(() => {
		if (consent === true) {
			initTelemetry();
			initGA();
		}
	}, [consent]);

	// Hide banner if user already made a choice (accept or reject)
	if (consent !== null) return null;

	const handleAccept = () => {
		setConsent(true);
		initTelemetry();
		initGA();
	};

	const handleReject = () => {
		setConsent(false);
	};

	return (
		<div className='cookie-consent-banner'>
			<div className='cookie-consent-inner'>
				<div className='cookie-consent-text'>
					<Icon icon='Cookie' size='2x' className='cookie-consent-icon' />
					<p>
						{t('We use cookies to enhance your experience and analyse site usage. Read our')}{' '}
						<a href='/privacy' className='cookie-consent-link'>
							{t('Privacy Policy')}
						</a>
						.
					</p>
				</div>
				<div className='cookie-consent-actions'>
					<Button
						color='light'
						size='sm'
						className='cookie-consent-btn'
						onClick={handleReject}>
						{t('Reject')}
					</Button>
					<Button
						color='primary'
						size='sm'
						className='cookie-consent-btn'
						onClick={handleAccept}>
						{t('Accept')}
					</Button>
				</div>
			</div>
		</div>
	);
};

export default CookieConsent;
